import controller from './display-only-field-controller';
import template from './display-only-field.html';

const DisplayOnlyFieldComponent = {
    bindings: {
        label: '<',
        labelClass: '<',
        hideLabel: '<',
        value: '<',
        valueClass: '<',
        lookupList: '<',
        lookupProp: '<'
    },
    controller,
    template
};

export default DisplayOnlyFieldComponent;



// WEBPACK FOOTER //
// ./app/common/form-fields/display-only-field/display-only-field-component.js